import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_dk9rugk66f: FaireCollectionEntity = {
  token: "pbc_dk9rugk66f",
  type: "collection",
  name: "shop COZY",
  heroImageUrl:
    "https://cdn.faire.com/fastly/59541b2acb06dc1f289c6416fe5de60e826f8780ee25b64e0e323e3b20732613.jpeg",
  itemCount: 10,
  description:
    "For styling tips or an exclusive look at new styles, check out our socials IG: @_lemonadeshoes or TIKTOK: @lemonadeshoes",
  brandToken: "b_mz3xxxsvnf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:31.206Z",
    importedBy: "entity-db-import-collections",
  },
};
